<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo d-flex">
      <router-link to="/" class="brand-logo d-flex">
        <b-img :src="require('@/assets/images/logo/logo.png')" alt="logo" />
        <h2 class="brand-text text-primary ml-1 mb-0 align-self-center">
          TaskFino
        </h2>
      </router-link>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Page Not Found 🕵🏻‍♀️</h2>
        <p class="mb-2">
          Oops! 😖 The requested URL was not found on this server.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="goBack"
        >
          Go to back
        </b-button>

        <!-- image -->
        <b-img fluid :src="imgUrl" alt="Error page" />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from "bootstrap-vue";
import store from "@/store/index";

export default {
  components: {
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/error.svg"),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/error-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
  },
  methods: {
    goBack() {
      const isSuperAdminAuthenticated = store.getters["superAdminAuthModule/getIsAuthenticated"];
      const isAdminAuthenticated = store.getters["authModule/getIsAuthenticated"];

      if (window.history.length > 1) {
        this.$router.go(-1); // Go back to the previous page
      } else {
        if (isSuperAdminAuthenticated) {
          this.$router.push({ name: "super-admin-dashboard" }); // Redirect to Super Admin Dashboard
        } else if (isAdminAuthenticated) {
          this.$router.push({ path: "/" }); // Redirect to normal admin's root page
        } else {
          this.$router.push({ name: "/" }); // Default fallback route
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
